<script>
import axios from 'axios';
import AppTable from "../form-generator/AppTable.vue";
import qs from 'qs';

export default {
  name: "multipurpose_vouchers",
  components: { AppTable },
  data() {
    return {
      app: {
        name: 'multipurpose_vouchers',
        data_url: '/multipurpose_vouchers.json',
        actions: [],
        hidden_id: true,
        filter_default_hidden: true,
      },
      fields: [
        {
          label: "Datum nákupu",
          type: "text",
          codename: "source_bought_at",
          display_filter: 'date'
        },
        {
          label: "Zdrojová objednávka",
          type: "text",
          codename: "source_order_id",
          display_filter: function (item) {
            if (item.source_order_id) {
              return `<a href="/orders/${item.source_order_id}">${item.source_order_number || item.source_order_id}</a>`
            }
            return item.source_order_number || '—'
          }
        },
        {
          label: "Kód poukazu",
          type: "text",
          codename: "code",
        },
        {
          label: "Cena za poukaz (Kč)",
          type: "text",
          codename: "source_order_total",
        },
        {
          label: "DPH zdroj. obj.",
          type: "text",
          codename: "source_vat",
          display_filter: function () {
            return '0 %'
          }
        },
        {
          label: "Bonusový",
          type: "text",
          codename: "is_bonus",
          display_filter: function (item) {
            return item.is_bonus
              ? '<span style="color:orange;font-weight:bold;">ANO</span>'
              : 'NE'
          }
        },
        {
          label: "Zrušen",
          type: "text",
          codename: "cancelled",
          display_filter: function (item) {
            return item.cancelled
              ? '<span style="color:red;font-weight:bold;">ANO</span>'
              : 'NE'
          }
        },
        {
          label: "Uplatněno",
          type: "text",
          codename: "used",
          display_filter: function (item) {
            if (item.used && item.used_order_id) {
              return `<a href="/orders/${item.used_order_id}" style="color:green;font-weight:bold;">ANO</a>`
            }
            return 'NE'
          }
        },
        {
          label: "Datum uplatnění",
          type: "text",
          codename: "used_at",
          display_filter: 'date'
        },
        {
          label: "Uplatňující objednávka",
          type: "text",
          codename: "used_order_id",
          display_filter: function (item) {
            if (item.used_order_id) {
              return `<a href="/orders/${item.used_order_id}">${item.used_order_number || item.used_order_id}</a>`
            }
            return '—'
          }
        },
        {
          label: "Cena s DPH (Kč)",
          type: "text",
          codename: "used_order_total",
          display_filter: function (item) {
            return item.used_order_total != null ? item.used_order_total : '—'
          }
        },
        {
          label: "Zdanění DPH (Kč)",
          type: "text",
          codename: "used_order_vat",
          display_filter: function (item) {
            return item.used_order_vat != null ? item.used_order_vat : '—'
          }
        },
      ],
      filters: [
        {
          type: 'search'
        },
        {
          label: "Uplatněno",
          type: "select",
          codename: "used",
          default: '',
          options: [
            { label: '- nefiltrovat -', value: '' },
            { label: 'Ano', value: 'true' },
            { label: 'Ne', value: 'false' }
          ]
        },
        {
          label: "Bonusový poukaz",
          type: "select",
          codename: "is_bonus",
          default: '',
          options: [
            { label: '- nefiltrovat -', value: '' },
            { label: 'Ano (bonusový)', value: 'true' },
            { label: 'Ne (placený)', value: 'false' }
          ]
        },
        {
          label: "Datum nákupu poukazu",
          type: "date-range",
          codename: "source_date",
        }
      ]
    }
  },
  methods: {
    export_xls() {
      let f = this.$refs.table.get_filters()
      let url = '/multipurpose_vouchers/export_xls'
      const aa = document.getElementById('mp-dld')
      const queryString = qs.stringify(f)
      aa.href = `${url}?${queryString}`
      aa.click()
    }
  }
}
</script>

<template>
  <div class="card card-body index p-2">
    <h1>Víceúčelové dárkové poukazy</h1>

    <div style="text-align:right">
      <button @click.prevent="export_xls">Export XLSX</button>
      <a id="mp-dld"></a>
    </div>

    <AppTable
      :app="app"
      :fields="fields"
      :default_per="50"
      :enable_search="true"
      :filters="filters"
      ref="table"
    />
  </div>
</template>

<style>
</style>
